'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uuid = require('./uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _uuid2.default;


//////////////////
// WEBPACK FOOTER
// ./~/performance-uuid/lib/index.js
// module id = 559
// module chunks = 0